import React from 'react'
import PropTypes from 'prop-types'
import {startOfMonth, startOfWeek, addWeeks} from 'ag-common/facades'
import _ from 'lodash'
import DatePickerTableHeaderCell from './DatePickerTableHeaderCell'
import DatePickerKWCell from './DatePickerKWCell'

function DatePickerKWColumn({date}) {
  return (
    <div className="date-picker-kw-column">
      <div className="the-column">
        <DatePickerTableHeaderCell text="KW" />
        {_.range(0, 6).map(n => (
          <DatePickerKWCell
            key={`date-picker-kw-cell-${n}`}
            date={addWeeks(startOfWeek(startOfMonth(date), {weekStartsOn: 1}), n)}
          />
        ))}
      </div>
      <div className="right-border" />
    </div>
  )
}

DatePickerKWColumn.propTypes = {
  date: PropTypes.instanceOf(Date),
}

export default DatePickerKWColumn
